import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { LucideMoreHorizontal } from 'lucide-react';

interface PaginationEllipsisButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
}

export const PaginationEllipsisButton: React.FC<PaginationEllipsisButtonProps> = React.memo(
  ({ direction, onClick }) => {
    const label = direction === 'prev' ? 'Jump back 5 pages' : 'Jump forward 5 pages';

    return (
      <IconButton
        aria-label={label}
        icon={<LucideMoreHorizontal size={18} />}
        size="xs"
        variant="ghost"
        onClick={onClick}
      />
    );
  },
);

PaginationEllipsisButton.displayName = 'PaginationEllipsisButton';
